import request from './request';

const fetchC2CCategories = async () => {
    return request('/v1/public/web-proxy-api/loadC2CCategories');
};

const fetchVEHCategories = () => {
    return request('/v1/public/web-proxy-api/loadXeCategories');
};

export { fetchC2CCategories, fetchVEHCategories };
